module.exports = __webpack_public_path__ + "static/media/blue-check.22863508.svg";